import { CurrentUser } from "app/shared/model/CurrentUser";
import { CurrentUserState } from "app/shared/currentUser/state";

export function getRoot(state: any) : CurrentUserState {
    return state.currentUser as CurrentUserState;
}

export function getCurrentUser(state: any) : CurrentUser {
    return getRoot(state).user;
}

export function getCurrentVersion(state: any) : string {
    return getRoot(state).version;
}